import {FETCH_BUDGET_CHILDREN, RECEIVE_BUDGET_CHILDREN, FAILED_BUDGET_CHILDREN} from '../../actions/budgeting/aBudget-YearlyChildren'

const defaultChildrenList = {
    data: []
}

export function fetchBudgetYearlyChildren(state = defaultChildrenList, action){
    switch(action.type){
        case FETCH_BUDGET_CHILDREN:
            return({data: [], inProgress: true})
        case RECEIVE_BUDGET_CHILDREN:
            console.log(action.payload)
            return Object.assign({}, state, {data: action.payload, inProgress: false})
        case FAILED_BUDGET_CHILDREN:
            return({data: [], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/budgeting/redBudgeting-YearlyChildren.jsx